export enum SdohReferralStatusReason {
  Staffing = 'Staffing',
  PendingWithdrawal = 'PendingWithdrawal',
  PendingFV = 'PendingFV',
  PendingFVForm = 'PendingFVForm',
  FVReview = 'FVReview',
  SVReview = 'SVReview',
  PendingSV = 'PendingSV',
  PendingSVForm = 'PendingSVForm'
}

export const SdohReferralStatusReasonLabelMap: { [key: string]: string } = {
  [SdohReferralStatusReason.Staffing]: 'Staffing',
  [SdohReferralStatusReason.PendingWithdrawal]: 'Pending Withdrawal',
  [SdohReferralStatusReason.PendingFV]: 'Pending FV',
  [SdohReferralStatusReason.PendingFVForm]: 'Pending FV Form',
  [SdohReferralStatusReason.FVReview]: 'FV Review',
  [SdohReferralStatusReason.SVReview]: 'SV Review',
  [SdohReferralStatusReason.PendingSV]: 'Pending SV',
  [SdohReferralStatusReason.PendingSVForm]: 'Pending SV Form'
};
